import { render } from "./host-selection.vue?vue&type=template&id=2a674494&scoped=true"
import script from "./host-selection.vue?vue&type=script&lang=js"
export * from "./host-selection.vue?vue&type=script&lang=js"

import "./host-selection.vue?vue&type=style&index=0&id=2a674494&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a674494"]])

export default __exports__